<script>
    import { fly } from "svelte/transition";
    import { PdfViewer } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body nopadding">
        <PdfViewer textCopy/>
    </div>

    <!-- <h4 class="example-title">一次性加载</h4>
    <div class="example-body nopadding">
        <PdfViewer lazyLoad={false}/>
    </div> -->
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
